// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"47f674ef","453":"32a9d300"}[chunkId] + ".chunk.js";
};